import { Chip, Button, Stack } from '@mui/material';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import editFill from '@iconify/icons-eva/edit-fill';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';

// constants
import { statusColorMap, Status } from '../constants/ocpi.constant';
import { OCPI_ROLES } from 'src/utils/ocpi.constants';

export const tariffTableColumns = (onView, onEdit, onDelete) => [
  {
    field: 'id',
    headerName: 'Tariff ID',
    flex: 1,
    minWidth: 150,
    resizable: true,
  },
  {
    field: 'tariffType',
    headerName: 'Type',
    flex: 0.8,
    minWidth: 120,
    resizable: true,
    renderCell: ({ value }) => (
      <Chip
        label={value}
        variant="outlined"
        size="small"
        color="primary"
      />
    ),
  },
  {
    field: 'countryCode',
    headerName: 'Country/Party',
    flex: 1,
    minWidth: 150,
    resizable: true,
    valueGetter: (params) => `${params.row.countryCode} - ${params.row.partyId}`,
  },
  {
    field: 'currency',
    headerName: 'Currency',
    flex: 0.6,
    minWidth: 100,
    resizable: true,
  },
  {
    field: 'energyMix',
    headerName: 'Energy Category',
    flex: 1,
    minWidth: 150,
    resizable: true,
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 0.7,
    minWidth: 100,
    resizable: true,
    renderCell: ({ row }) => (
      <Chip
        label={row.active ? Status.VALID : Status.INVALID}
        color={statusColorMap[row.active ? Status.VALID : Status.INVALID]?.color || 'default'}
        size="small"
        variant="filled"
        sx={{
          fontWeight: 600,
          fontSize: '0.7rem',
          height: 24,
          bgcolor: statusColorMap[row.active ? Status.VALID : Status.INVALID]?.bgcolor || 'grey.200',
          color: statusColorMap[row.active ? Status.VALID : Status.INVALID]?.text || 'text.secondary',
        }}
      />
    ),
  },
  {
    field: 'lastUpdated',
    headerName: 'Last Updated',
    flex: 1,
    minWidth: 150,
    resizable: true,
    type: 'date',
    valueFormatter: ({ value }) => {
      if (!value) return 'N/A';
      return new Date(value).toLocaleDateString();
    },
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 200,
    minWidth: 200,
    sortable: false,
    resizable: false,
    renderCell: ({ row }) => (
      <Stack direction="row" spacing={1}>
        <Button
          size="small"
          variant="outlined"
          startIcon={<Icon icon={eyeFill} width={16} height={16} />}
          onClick={() => onView(row.id || row.tariff_id)}
          sx={{
            fontSize: '0.75rem',
            px: 1.5,
            py: 0.5,
            minWidth: 'auto',
            height: 32,
            borderColor: 'grey.300',
            color: 'text.primary',
            '&:hover': {
              borderColor: 'grey.400',
              backgroundColor: 'grey.50'
            }
          }}
        >
          View
        </Button>
        {row.role !== OCPI_ROLES.CPO && (
          <>
            <Button
              size="small"
              variant="outlined"
              startIcon={<Icon icon={editFill} width={16} height={16} />}
              onClick={() => onEdit(row.id || row.tariff_id)}
              sx={{
                fontSize: '0.75rem',
                px: 1.5,
                py: 0.5,
                minWidth: 'auto',
                height: 32,
                borderColor: 'grey.300',
                color: 'text.primary',
                '&:hover': {
                  borderColor: 'grey.400',
                  backgroundColor: 'grey.50'
                }
              }}
            >
              Edit
            </Button>
            <Button
              size="small"
              variant="outlined"
              color="error"
              startIcon={<Icon icon={trash2Fill} width={16} height={16} />}
              onClick={() => onDelete(row.id || row.tariff_id)}
              sx={{
                fontSize: '0.75rem',
                px: 1.5,
                py: 0.5,
                minWidth: 'auto',
                height: 32,
                borderColor: 'error.main',
                color: 'error.main',
                '&:hover': {
                  borderColor: 'error.dark',
                  backgroundColor: 'error.lighter'
                }
              }}
            >
              Delete
            </Button>
          </>
        )}
      </Stack>
    ),
  },
];
